<template>
  <b-container class="p-0">
    <b-card>
      <app-timeline>
        <app-timeline-item
          title="Link Gerado"
          subtitle="Link Gerado com Sucesso"
          icon="CheckSquareIcon"
          variant="primary"
          data-aos="fade-in"
          data-aos-duration="700"
        />
        <app-timeline-item
          v-if="status.code !== 11 && status.code !== 12"
          title="Link Preenchido"
          subtitle="Link preenchido pelo Comprador"
          icon="EditIcon"
          variant="primary"
          data-aos="fade-in"
          data-aos-duration="750"
        />
        <app-timeline-item
          v-if="status.code !== 11 && status.code !== 12"
          title="Revisão"
          subtitle="Transação em Revisão"
          icon="AlertCircleIcon"
          variant="warning"
          data-aos="fade-in"
          data-aos-duration="800"
        />
        <app-timeline-item
          v-if="status.code == 1 || status.code == 2 || status.code == 9 || status.code == 11"
          :title="status.status"
          :subtitle="status.subtitleText"
          :icon="status.lastTimeLineIcon"
          :variant="status.variant"
          data-aos="fade-in"
          data-aos-duration="850"
        />
      </app-timeline>
    </b-card>
  </b-container>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'

import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

import {
  BCard,
  BContainer,
} from 'bootstrap-vue'

const { statusObjectTimeLine } = require('@/information/detailsTransaction')

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    BCard,
    BContainer,
  },

  props: {
    statusId: {
      type: Number,
      default: () => 1,
    },
  },

  created() {
    this.handleAnimationConfig()
    this.handleDoStatus()
  },

  methods: {
    handleDoStatus() {
        this.status = statusObjectTimeLine[this.statusId]
    },
    handleAnimationConfig() {
      AOS.init({
        offset: 120,
        delay: 0,
        duration: 1000,
        easing: 'ease-in',
        once: true,
        anchorPlacement: 'top-bottom',
      })
    },
  },
}
</script>
